import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { UserLogin, User, ResetPasswordSentEmailModel, TokenSearchModel, ResetPasswordModel } from "../model/user.model";

import "rxjs/add/operator/map";

const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class AuthenService {
    private Url = API_URL + '/authen';  // URL to web api

    currentLanguage: any;
    constructor(private http: HttpClient) {
    }


    login(authenuser: UserLogin): Observable<any> {
        return this.http.post<any>(this.Url + '/login', authenuser, httpOptions).pipe(
            tap((user: any) => {
                // this.log(`login w/ userLogin=${JSON.stringify(user)}`);
                // window.localStorage.setItem('currentUser', JSON.stringify(user));
            }),
            catchError(this.handleError<UserLogin>('Login Err'))
        );
    }

    logout(user: User) {
        // console.log("this.jwt()", this.jwt())
        return this.http.post(this.Url + '/logout', user, httpOptions)
            .pipe(
                tap((response: any) => {
                    // window.localStorage.removeItem('currentUser');
                    // this.log(`Logout`);
                }),
                catchError(this.handleError('Logout', []))
            );
    }


    verify(): Observable<Boolean> {
        // console.log("this.jwt()", this.jwt())

        return this.http.post(this.Url + '/verify', null, this.jwt())
            .pipe(
                tap((response: any) => this.log(`verify`)),
                catchError(this.handleError('verifyUserLogin', []))
            );
    }

    getIpAddress() {
        return this.http
            .get('https://jsonip.com')
            .pipe(
                tap((response: any) => this.log(`GetIPAddress`)),
                catchError(this.handleError('IPAddress', []))
            );
    }


    ResetPasswordSendEmail(model: ResetPasswordSentEmailModel): Observable<any> {
        return this.http.post<ResetPasswordSentEmailModel>(this.Url + '/resetpassword', model, httpOptions).pipe(
            tap((res: any) => {
                console.log(`send email`, res);
            }), catchError(this.handleError<ResetPasswordSentEmailModel>('send email'))
        );
    }

    GetEmailByToken(model: TokenSearchModel): Observable<any> {
        return this.http.post<TokenSearchModel>(this.Url + '/resetpassword/email', model, httpOptions).pipe(
            tap((res: any) => {
                console.log(`Get email`, res);
            }), catchError(this.handleError<TokenSearchModel>('resetpassword'))
        );
    }

    ResetPassword(model: ResetPasswordModel): Observable<any> {
        return this.http.post<ResetPasswordModel>(this.Url + '/Updatepassword', model, httpOptions).pipe(
            tap((res: any) => {
                console.log(`Reset Password email`, res);
            }), catchError(this.handleError<ResetPasswordModel>('Updatepassword'))
        );
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    private log(message: string) {
        // console.log(message);
        // this.messageService.add('JobSafetySettingService: ' + message);
    }


    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.Token) {
            // let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + currentUser.token });

            let hOptions = {
                headers: new HttpHeaders(
                    {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + currentUser.Token
                    }
                )
            };
            return hOptions;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/services/authen.service.ts